import { type Service } from 'schema-dts'

export const getServiceSchema = ({
  city,
  state,
  zip,
  canonicalUrl,
}: {
  city: string | undefined
  state: string | undefined
  zip: string | undefined
  canonicalUrl: string
}): Service | undefined => {
  if (city && state && zip) {
    return {
      '@type': 'Service',
      name: `Shipt same-day grocery delivery in ${city}, ${state}`,
      serviceType: ['Same-day delivery', 'Grocery delivery', 'Alcohol delivery'],
      provider: {
        '@type': 'Organization',
        name: 'Shipt',
        url: 'https://www.shipt.com',
      },
      areaServed: {
        '@type': 'City',
        name: city,
        address: {
          '@type': 'PostalAddress',
          addressLocality: city,
          addressRegion: state,
          postalCode: zip,
        },
      },
      url: canonicalUrl,
    }
  }
}
